import axios from "axios";
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            isCollective: false,
            selectedTree: [],
            treeExpandedKeys: [],
            costCenter: [],
            peruntukan: [],
            anggaran: {
                peruntukan_id: "",
                anggaran_id: "",
                id_kas: "",
                modalvalue: undefined,
                path: "",
                limit: 0,
                tree: [],
                treeModal: [],
                searchValue: "",
                loadingtree: false,
            },
        }
    },
    beforeCreate() {
        this.formCollective = this.$form.createForm(this);
    },
    computed: {
        ...mapGetters([
            "getJenisAnggaran"
        ])
    },
    methods: {
        onCollective() {
            this.isCollective = true;
            this.costCenter=[];
            this.peruntukan=[];
            this.anggaran.tree=[];
            this.selectedTree=[];
        },
        handleCloseCollective() {
            this.isCollective = false;
        },
        handleSet() {
            this.formCollective.validateFields((err, values) => {
                if (err) {
                    this.newLoading = false;
                    this.pageLoading = false;
                    this.displayMessage("form-warning");
                    return;
                }

                let kd = values.kode_anggaran.split(";");

                axios({
                    method: "put",
                    url: this.type == 'revised' ? this.$serviceUrl + "kas_kecil/revisi_detil_kas_kecil_kolektif" : this.$serviceUrl + "kas_kecil/detil_kas_kecil_draft_kolektif",
                    processData: false,
                    data: {
                        "id_kas": this.id_kas,
                        "cost_center": values.cost_center,
                        "peruntukan": values.peruntukan,
                        "anggaran_dtl_val_id": kd[kd.length - 1],
                        "path": this.anggaran.path,
                        "tlc": this.getAuth.username,
                        "selected_item": this.selectedTree,
                    },
                    auth: {
                        username: this.getAuth.username,
                        password: this.getAuth.password,
                    },
                    headers: {
                        "Content-Type": "application/json",
                        "X-API-KEY": this.getAuth.apikey,
                    },
                }).then(response => {
                    this.fetchPemakaian();
                    this.reset();
                    this.displayMessage("success-save")
                }).catch(err => {
                    this.displayMessageValue("error", err.response.data.message)
                });
            })
        },
        handleJenisAnggaran(e) {
            this.formCollective.resetFields([
                "cost_center",
                "peruntukan",
                "sub_peruntukan",
                "kode_anggaran",
            ]);
            const filter = this.getCostCenter.filter(
                (obj) => obj.jns_anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
            );

            this.costCenter = filter;
            this.subPeruntukan = [];
            this.peruntukan = [];
            this.anggaran.tree = [];
            this.anggaran.treeModal = [];
        },
        handleCost(e) {
            this.formCollective.resetFields(["peruntukan", "sub_peruntukan", "kode_anggaran"]);
            this.subPeruntukan = [];
            this.anggaran.tree = [];
            this.anggaran.treeModal = [];
            const peruntukan = this.getPeruntukan.filter(
                (obj) => obj.anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
            );
            this.peruntukan = peruntukan;

            this.anggaran.anggaran_id = e;
        },
        handleCheck(e) {
            const item = e.target.value;
            this.selectedTree.indexOf(item) == -1 ? this.selectedTree.push(item) : this.selectedTree.splice(this.selectedTree.indexOf(item), 1)
        },
        handlePeruntukan(e) {
            this.formCollective.resetFields(["sub_peruntukan", "kode_anggaran"]);
            this.anggaran.peruntukan_id = e;
            this.anggaran.tree = [];
            this.anggaran.treeModal = [];
            const filter = this.getSubPeruntukan.filter(
                (obj) => obj.peruntukan_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
            );
            this.subPeruntukan = filter;
            this.getTreeAnggaran();
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
            );
        },
        filterTreeNode(input, option) {
            return (
                option.data.props.texttitle == undefined ||
                (option.data.props.texttitle ? option.data.props.texttitle : "")
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0 ||
                (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "")
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
            );
        },
        handlechoiceCost(value, record) {
            this.anggaran.limit = record.dataRef.rekap;
            this.anggaran.path = record.dataRef.path;
        },
        getTreeAnggaran() {
            this.anggaran.loadingtree = true;
            let dataParams =
                this.mode == "Edit" && this.type == "revised"
                    ? {
                        anggaran_id: this.anggaran.anggaran_id,
                        peruntukan_id: this.anggaran.peruntukan_id,
                        id_kas: this.id_kas,
                    }
                    : {
                        anggaran_id: this.anggaran.anggaran_id,
                        tlc: this.getAuth.username,
                        peruntukan_id: this.anggaran.peruntukan_id,
                    };
            if (dataParams.peruntukan_id) {
                axios({
                    method: "get",
                    url: this.$serviceUrl + "kas_kecil/tree_anggaran",
                    params: dataParams,
                    auth: {
                        username: this.getAuth.username,
                        password: this.getAuth.password,
                    },
                    headers: {
                        "X-API-KEY": this.getAuth.apikey,
                    },
                })
                    .then((response) => {
                        this.anggaran.tree = response.data.tree;
                        this.anggaran.treeModal = [
                            ...this.anggaran.treeModal,
                            response.data.tree[0],
                        ];
                        let arr = this.dataList.filter((item) => item.kredit !== "");
                        this.recountingAnggaran(arr);
                        this.anggaran.loadingtree = false;

                        this.treeExpandedKeys = this.getParent(response.data.tree);
                    })
                    .catch((err) => {
                        this.anggaran.loadingtree = false;
                        console.log(err);
                        let responses = Object.assign({}, err.response);
                        this.displayMessageValue("error", responses);
                    });
            }
        },
        recountingAnggaran(arr) {
            arr = arr.filter((obj) => obj.path !== "");
            if (arr.length > 0) {
                //restore nominal ke origin
                arr.forEach((elm) => {
                    if (elm.path) {
                        let ObjVal = elm.path.split(";");
                        let path1 = "";
                        let path2 = "";
                        let path3 = "";
                        let trigerpath = true;
                        let tempTree = this.anggaran.tree;
                        ObjVal.forEach((element) => {
                            if (path1 == "") {
                                path1 += "tempTree[" + element + "]";
                                path3 = path1;
                            } else {
                                path3 = path1 + ".children";
                                path1 += ".children[" + element + "]";
                            }
                            if (trigerpath) {
                                if (!eval(path3)) {
                                    trigerpath = false;
                                    return;
                                } else {
                                    if (!eval(path1)) {
                                        trigerpath = false;
                                        return;
                                    }
                                }
                            }
                        });

                        if (trigerpath) {
                            path2 = eval(path1 + ".origin_rekap");
                            eval(path1 + ".rekap=" + path2);
                            //eval(path1+".disabled=false")
                        }
                    }
                });
                //menghitung nominal dengan acuan nominal origin
                arr.forEach((elem) => {
                    if (elem.path) {
                        let ObjVal = elem.path.split(";");
                        let path = "";
                        let tpath = "";
                        let trigerpath = true;
                        let tempTree = this.anggaran.tree;
                        ObjVal.forEach((element) => {
                            if (path == "") {
                                path += "tempTree[" + element + "]";
                                tpath = path;
                            } else {
                                tpath = path + ".children";
                                path += ".children[" + element + "]";
                            }
                            if (trigerpath) {
                                if (!eval(tpath)) {
                                    trigerpath = false;
                                    return;
                                } else {
                                    if (!eval(path)) {
                                        trigerpath = false;
                                        return;
                                    }
                                }
                            }
                        });
                        if (trigerpath) {
                            let kd_anggrn = eval(path + ".kode_anggaran");
                            if (kd_anggrn == elem.kode_anggaran) {
                                let oldVal = eval(path + ".rekap");
                                let num = oldVal - parseFloat(elem.kredit);
                                let exe = path + ".rekap=" + num;
                                eval(exe);
                                if (num <= 0) {
                                    eval(path + ".disabled=true");
                                } else {
                                    eval(path + ".disabled=false");
                                }
                            }
                        }
                        this.anggaran.tree = tempTree;
                    }
                });
            }
        },
        getParent(root) {
            let data = [];
            root.forEach((item) => {
                if (item.key) {
                    data.push(item.key);
                }

                if (item.children.length > 0) {
                    item.children.forEach((d) => {
                        data.push(d.key);
                    });
                }
            });
            return data;
        },
        reset() {
            this.costCenter = [],
                this.peruntukan = [],
                this.treeExpandedKeys = [],
                this.anggaran = {
                    peruntukan_id: "",
                    anggaran_id: "",
                    id_kas: "",
                    modalvalue: undefined,
                    path: "",
                    limit: 0,
                    tree: [],
                    treeModal: [],
                    searchValue: "",
                    loadingtree: false,
                },
                this.selectedTree = [],
                this.formCollective.resetFields();
        },
    }
}